require('./dist/polyfill');



//////////////////
// WEBPACK FOOTER
// ../~/@formatjs/intl-relativetimeformat/polyfill.js
// module id = 1471
// module chunks = 121